import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconShareAndroidComponent } from "./med-icon-share-android.component";

@NgModule({
  declarations: [
    MedIconShareAndroidComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconShareAndroidComponent,
  ],
})
export class MedIconShareAndroidModule { }
